import { render, staticRenderFns } from "./DocumentManager.vue?vue&type=template&id=efceedec&scoped=true&"
import script from "./DocumentManager.vue?vue&type=script&lang=js&"
export * from "./DocumentManager.vue?vue&type=script&lang=js&"
import style0 from "./DocumentManager.vue?vue&type=style&index=0&id=efceedec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efceedec",
  null
  
)

export default component.exports